// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".excise-stamps__hint[data-v-0314964e]{font-size:.75rem;line-height:1.3;margin:-15px 0 20px}", ""]);
// Exports
module.exports = exports;
